const PING_INTERVAL = 12 * 60 * 60 * 1000;
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY;

const generateRandomEmail = () => {
  const randomString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  return `ping-${randomString}@keepalive.local`;
};

const pingBackend = async () => {
  if (!SUPABASE_URL || !SUPABASE_KEY) return;
  
  try {
    const randomEmail = generateRandomEmail();
    await fetch(`${SUPABASE_URL}/rest/v1/email_list`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${SUPABASE_KEY}`,
        Prefer: 'return=representation',
      },
      body: JSON.stringify({ email: randomEmail }),
    });
  } catch (error) {
  }
};

export const startPingService = () => {
  pingBackend();
  
  const intervalId = setInterval(() => {
    pingBackend();
  }, PING_INTERVAL);
  
  const handleVisibilityChange = () => {
    if (!document.hidden) {
      pingBackend();
    }
  };
  
  document.addEventListener('visibilitychange', handleVisibilityChange);
  
  return () => {
    clearInterval(intervalId);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };
};

export const stopPingService = (cleanup) => {
  if (cleanup) {
    cleanup();
  }
};

